import { BnModalMixin } from '../../common/bn-modal-mixin';
import { html, LitEntity } from '../../utility/lit-entity';
import '../../common/bn-loading';
import './assign-installer';

class AssignInstallerModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'assign-installer-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 80%;
          --modal-max-width: 80%;
          --modal-body-overflow-y: visible;
        }
      </style>
      <h3 slot="title">Assign Work Order</h3>
      ${this._renderBody()}
    `;
  }

  _renderBody() {
    const selectInstallerAction = this.entity && this.entity.getActionByName('select-installer');
    if (!selectInstallerAction) {
      return html`<bn-loading></bn-loading>`;
    }
    return html`
      <assign-installer
        .href="${selectInstallerAction.href}"
        @response="${this._onResponse}"
      ></assign-installer>
    `;
  }

  _onResponse(e) {
    this.dispatchEvent(new CustomEvent('response'), { detail: e.detail, bubbles: true, composed: true });
    this.close();
  }
}

window.customElements.define('assign-installer-modal', AssignInstallerModal);
